import axios from "axios";
// import { toast } from "react-toastify";
// import logger from "./logService"
//import auth from "./authService"
//axios.defaults.headers.common['x-auth-token'] = auth.getJwt();

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  // Handle password expiry (403 - password expired)
  if (error.response?.status === 403) {
    const responseData = error.response?.data;
    if (responseData?.passwordExpired === true) {
      clearLocalStorageAuth();
      window.location = "/updatePass?reason=expired";
      return Promise.reject(error);
    }
  }

  // Handle invalid token (401 - no token, 400 - invalid/expired token)
  if (error.response?.status === 401 || error.response?.status === 400) {
    const responseData = error.response?.data;

    // Modern Type-Safe String matching check helper
    const hasTokenError = (data) => {
      if (!data) return false;
      // If data is a direct string: e.g. "Invalid token"
      if (typeof data === "string") {
        return data.includes("Invalid token") || data.includes("Access denied");
      }
      // If data is an object: e.g. { message: "Invalid token" } or { error: "Access denied" }
      if (typeof data === "object") {
        const checkValue = data.message || data.error || "";
        return (
          checkValue.includes("Invalid token") ||
          checkValue.includes("Access denied")
        );
      }
      return false;
    };

    if (error.response?.status === 401 || hasTokenError(responseData)) {
      clearLocalStorageAuth();
      window.location = "/login";
      return Promise.reject(error);
    }
  }

  if (!expectedError) {
    // logger.log(error)
    // console.log("Logging the error", error);
    // toast.error("An unexpected error occurred.");
  }

  return Promise.reject(error);
});

// Helper function to keep cleaning footprints DRY and maintainable
function clearLocalStorageAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("attemptAndTimeMCQ");
  localStorage.removeItem("attemptAndTimeListeningQ1");
  localStorage.removeItem("attemptAndTimeListeningQ2");
  localStorage.removeItem("attemptAndTimeListeningQ3");
  localStorage.removeItem("attemptAndTimeWriting");
}

function setJwt(jwt) {
  if (jwt) {
    axios.defaults.headers.common["x-auth-token"] = jwt;
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
  }
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
};
